import { useShallow } from 'zustand/shallow';
import { StoreApi, UseBoundStore } from 'zustand';

export function createShallowStoreHook<T extends object>(
  useStore: UseBoundStore<StoreApi<T>>,
) {
  return () => {
    const state = useStore(
      useShallow((state: T) => {
        const storeKeys = Object.keys(state) as (keyof T)[];
        const selector = {} as T;
        for (const key of storeKeys) {
          selector[key] = state[key];
        }
        return selector;
      })
    );
    
    return state;
  };
}